import Campaigns from './Campaigns.js';
import enhance from './enhancer';

export default enhance(Campaigns);
